import { RemoteAsset } from "./remote-asset";
import { Ticket } from "./ticket";

export class Attachment extends RemoteAsset {
  tiket_id: number;
  ticket: Ticket;
  count: number;
  _destroy: boolean = false;
  file: File;
  _fileSize: number;

  constructor(data:any) {
    super(data);
    this.initData();
    this._fileSize = data ? data.fileSize || 0 : 0;
  }

  initData(){
    if (this.ticket && !(this.ticket instanceof Ticket)) {
      this.ticket = new Ticket(this.ticket);
    }
  }

  formatFileSize(): string {
    const realSize = this.file ? this.file.size : this._fileSize;
    if(!realSize) return '';
    if (realSize === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(realSize) / Math.log(k));
    return parseFloat((realSize / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  }

  get fileSize(): number {
    return this.file ? this.file.size : this._fileSize;
  }

  set fileSize(value: number) {
    this._fileSize = value;
  }

  get saveProp(): string[] {
    if (this._destroy)
      return ["id", "_destroy"]
    else {
      let p = super.saveProp;
      if (!this.stored)
        p.push("base64", "filename","file");
      return p;
    }
  }
}
